import get from "lodash.get";
import { textStyles } from "~/styleguide/typography";
import { colors } from "~/styleguide";
import { FelaComponent } from "react-fela";
import { combineRules } from "fela";

import WordpressLink from "~/components/global/links";

export default function TaxonomyList({
    resource,
    extend,
    slug = "category",
    dataKey = "categories",
    label
}) {
    const items = get(resource, dataKey, []);

    if (!items || !items.length) return null;

    return (
        <FelaComponent as="div" style={extend}>
            {label && (
                <span>
                    <strong>{label}: </strong>
                </span>
            )}

            {items &&
                items.map((item, index) => {
                    return (
                        <FelaComponent
                            key={index}
                            style={combineRules(textStyles.tag, tagListStyle)}
                        >
                            <WordpressLink
                                label={item.name}
                                url={`/blog/${slug}`}
                                slug={item.slug}
                                key={index}
                                extend={{
                                    whenActive: {
                                        color: colors.blue
                                    }
                                }}
                            />
                        </FelaComponent>
                    );
                })}
        </FelaComponent>
    );
}

const tagListStyle = {
    marginRight: 5,
    after: "','"
};
